/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { api } from '../../../redux/api';
import { getCookie } from '../../../hookServices/cookiesManager';
import Spinner from '../../loaders/globalSpinner/Spinner';

export default function StationNumberLayout({ fingerPrint }) {
  const [searchParams] = useSearchParams();
  let stationNumber = searchParams.get('station');

  const [station, setStation] = useState();
  const [isFetchingStation, setIsFetchingStation] = useState(true);
  const [isLoadingStation, setIsLoadingStation] = useState(true);
  const [isErrorStation, setIsErrorStation] = useState(false);

  const [getDeviceStation] = api.useLazyGetDeviceStationQuery();

  const getDeviceStationInfo = async position => {
    setIsFetchingStation(true);
    setIsLoadingStation(true);
    try {
      const {
        data: stationData,
        isError: isErrorStationResult,
        error,
      } = await getDeviceStation({
        stationNumber,
        lat: position ? position.latitude : '',
        lon: position ? position.longitude : '',
        fingerPrint,
      });
      // 429/errors return no data — still settle so the start-page loader cannot hang forever.
      if (stationData && !isErrorStationResult) {
        setStation(stationData);
        setIsErrorStation(false);
      } else {
        setStation(undefined);
        setIsErrorStation(true);
        if (error) {
          console.error('getDeviceStation failed', error);
        }
      }
    } catch (err) {
      console.error('getDeviceStation failed', err);
      setStation(undefined);
      setIsErrorStation(true);
    } finally {
      setIsFetchingStation(false);
      setIsLoadingStation(false);
    }
  };

  useEffect(() => {
    const position = getCookie('userLocation');
    if (position?.latitude != null && position?.longitude != null) {
      getDeviceStationInfo(position);
    } else {
      getDeviceStationInfo();
    }
    //eslint-disable-next-line
  }, []);

  if (isLoadingStation || isFetchingStation) {
    return <Spinner pageCentered />;
  }

  const openFrom = station?.openFrom?.slice(0, 5);
  const closedFrom = station?.closedFrom?.slice(0, 5);
  const isTwentyFourHour = station?.openFrom === '00:00:00' && station?.closedFrom === '00:00:00';

  return (
    <Outlet
      context={{
        station,
        stationNumber,
        openFrom,
        closedFrom,
        isTwentyFourHour,
        isFetchingStation,
        isLoadingStation,
        isErrorStation,
      }}
    />
  );
}
